import React from 'react';
import { IconsPros } from './types';

/**
 * Edit Icon component
 *
 * @returns JSX.ELEMENT
 */
export const EditIcon = ({ 'data-testid': dataTestId }: IconsPros) => {
  return (
    <svg viewBox="0 0 16 16" data-testid={dataTestId}>
      <rect
        x="0.59"
        y="6.66"
        width="13.5"
        height="4"
        transform="translate(-3.97 7.73) rotate(-45)"
      />
      <path d="M15.83,2.64,13.36.17a.25.25,0,0,0-.35,0L11.76,1.41l2.83,2.83L15.83,3A.25.25,0,0,0,15.83,2.64Z" />
      <path d="M.1,15.65a.25.25,0,0,0,.25.25H2.93L.1,13.07Z" />
    </svg>
  );
};
